import VueAgile from './Agile.vue'

const install = (Vue) => {
	Vue.component('agile', VueAgile)
}

export default {
	install
}

export { VueAgile }



//////////////////
// WEBPACK FOOTER
// ./~/vue-agile/src/index.js
// module id = 291
// module chunks = 1